module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noItemsMessage":"No news to show.","ePaperLinkText":"Read AKT e-paper"},"fi":{"noItemsMessage":"Uutisia ei löytynyt.","ePaperLinkText":"Siirry AKT:n verkkolehteen"}}')
  delete Component.options._Ctor
}
